<template>
  <ProxyImg v-if="data" :img="data.background" @load="$emit('load',$el,data)">
    <img class="abs-h-center flash-img" :src="data.gif.url" :style="data.gif.style" />
    <img class="abs-h-center code-box code-source" :src="data.code.url" :style="data.code.style" />
    <div class="abs-h-center code-box code-result" :style="data.result.style">
      <div v-if="!isShowResult" class="mask">
        <div class="btn" @click="handleRun">运行看看</div>
      </div>
      <div :style="`background:url(${data.result.url}) center/cover no-repeat;`" class="result-img"></div>
    </div>
  </ProxyImg>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import ProxyImg from '@/modules/common/ProxyImg';
import { setItem, getItem } from '@/lib/storage';
interface IRes {
  url: string;
  style: string;
}
export interface IConfig {
  background: string[];
  code: IRes;
  result: IRes;
  gif: IRes;
}
@Component({
  components: {
    ProxyImg,
  },
})
export default class StaticCode extends Vue {
  @Prop(Object) data!: IConfig;
  @Prop({ type: Number, default: 0 }) productionId!: number;
  isShowResult = false;
  get cacheKey() {
    return 'code_run_record_' + this.productionId;
  }
  beforeMount() {
    const record = Boolean(getItem(this.cacheKey));
    if (record) {
      this.isShowResult = true;
    }
  }
  handleRun() {
    this.isShowResult = true;
    setItem(this.cacheKey, true);
    this.$emit('track-btn-click', {
      button_name: '运行看看',
      tracking_subscene: '闪光弹报名页',
    });
  }
}
</script>

<style lang="scss">
@import '@/style/helps.scss';
.abs-h-center {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
}
.code-source {
  background: #19171d;
}
.code-box {
  max-width: 575px;
  border: solid 5px #6236d9;
  border-radius: 20px;
}
.flash-img {
  max-width: 594px;
}
.code-result {
  top: 1642px;
  z-index: 1;
  width: 575px;
  height: 260px;
  background: #19171d;
  .mask {
    @include flex-center;
    @include absolute-cover;
    background: #19171d;
    border-radius: 18px;
    .btn {
      @include button;
      @include flex-center;
      width: 219px;
      height: 78px;
      color: #fff;
      font-size: 30px;
      background: #6432d8;
      border-radius: 39px;
    }
  }
  .btn-wrapper {
    border-radius: 40px;
    // background: #fff;
  }
  .result-img {
    width: 100%;
    height: 100%;
    border-radius: 18px;
  }
}
</style>